import React from 'react';
import { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export function SkillGauge2(){



    const sgauges2 = [
      { sgid: 13, name: "HTML", percent: '100%' },
      { sgid: 14, name: "CSS", percent: '90%' },
      { sgid: 15, name: "JavaScript", percent: '85%' },
      { sgid: 16, name: "PHP", percent: '75%' },
      { sgid: 17, name: "TypeScript", percent: '25%' },
      { sgid:18, name: "MySQL", percent: '80%' }, 
      { sgid:19, name: "Liquid", percent: '75%' }, 
    ];

  
    const skill_gauge_ref2 = useRef(); 
// =================== //
// JS/GSAP ANIMATION 
// ===================//
useGSAP(() => {


   
    let thumb2 = document.querySelectorAll('.skill_gauge2'); 
   
   
   ScrollTrigger.batch(thumb2, {
    start: 'center bottom',
     once:true,  // <<< ==== ======================================= This makes it pin only once !!!
    onEnter: batch => {
      batch.forEach((section2, index) => {
 
       let tl_sg2 = gsap.timeline({});
       let gauge_needle2 = section2.querySelectorAll('.skill_gauge_needle2');
       let gauge_bar2 = section2.querySelectorAll('.skill_gauge_bar_bg2 path');


        // TEXT PERCENTAGE ANIMATION
        let txtPercent2 = section2.querySelector(".skill_gauge_txt2"); // get value
        let tPercent2 = txtPercent2.textContent;
        let tPercentClean2 = tPercent2.replace('%', '');// clean out our percentage symbol for the gauge animations
        let txtP2 =  tPercentClean2 / 100 * 180; // do the mastch for our half circle object
        //console.log(tPercentClean);


    tl_sg2.from(txtPercent2, {
      textContent: 0 + '%',
      duration: 1.5,
      ease: "power1.in",
      snap: { textContent: 1 },
       stagger: 1,
       dealy:2,
    })

   .to(gauge_needle2, {
       duration:1,
       rotation: txtP2 ,  
       stagger: 0.2,
       transformOrigin:"113px 20px", 
      delay: 0,
     ease: "power2.out",
        }, 0.4 )
      
    .to(gauge_bar2, {
      stagger: 0.2,
      duration:1, 
      rotation: txtP2  ,
      transformOrigin:"150px 150px", 
      delay: -0.65,
      ease: "power2.out",
        }, 1 );

      })
    },
    once: true
  });


  }, {scope: skill_gauge_ref2 });
// End of useGSAP


// PRINT SKILL GAUGE
return (
 <div className="skill_gauge_container" ref={skill_gauge_ref2}>
   
{sgauges2.map((gauge2) => (
          
        <div className="skill_gauge2" key={gauge2.id}>
          <svg className="skill_gauge_cont" version="1.1" x="0px" y="0px" viewBox="0 0 300 172">
            <text x="50%" y="70%" className="skill_gauge_txt2" alignment-baseline="middle" text-anchor="middle">{gauge2.percent}</text>
            <defs>
              <clipPath id={"xclipPath"+(gauge2.sgid)}>
              <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
              </clipPath>
              </defs>
              <g className="skill_gauge_indicator2">
                       <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" /></g>

                    <g className="skill_gauge_bar_bg2" style={{"clipPath":"url(#xclipPath"+(gauge2.sgid)+")" }}> 
                      <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" /></g>

                    <g className="skill_gauge_needle2"><path d="M133.1,139.4l-96.4,10.7l96.4,10.4c3.5,5.7,9.8,9.5,17,9.5c11,0,20-9,19.9-20.1c0-11-9-20-20.1-19.9C142.9,129.9,136.6,133.7,133.1,139.4z"/></g>
             </svg><div className="gauge-title">{gauge2.name}</div>

     </div>
   ))}

</div>
);
  




	

 }
        